import { render, staticRenderFns } from "./TablePaymentPromo.vue?vue&type=template&id=08d5039f"
import script from "./TablePaymentPromo.vue?vue&type=script&lang=js"
export * from "./TablePaymentPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports